import { render, staticRenderFns } from "./chirp-item.vue?vue&type=template&id=93f69738&scoped=true&"
import script from "./chirp-item.vue?vue&type=script&lang=js&"
export * from "./chirp-item.vue?vue&type=script&lang=js&"
import style0 from "./chirp-item.vue?vue&type=style&index=0&id=93f69738&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f69738",
  null
  
)

export default component.exports